export default [
  {
    path: '/apps/grupo-comercial/list',
    name: 'apps-grupo-comercial-list',
    component: () => import('@/views/cadastros/cliente/grupo-comercial/list/Index.vue'),
    meta: {
      pageTitle: 'Grupo Comercial',
    },
  },
];
